<input
	class="!w-32 rounded-md text-center cursor-text"
	[class.border-red-600]="checkValue && (control.touched && control.invalid)"
    [class.border-2]="checkValue && (control.touched && control.invalid)"
    [class.border-solid]="checkValue && (control.touched && control.invalid)"
	matInput
	#trigger="matAutocompleteTrigger"
    [type]="type"
    [placeholder]="placeholder"
    [formControl]="control"
    [matAutocomplete]="auto"
    (click)="trigger.openPanel()" 
/>

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let item of items" [value]="modifyFn(item)">
        {{ modifyFn(item) }}
    </mat-option>
</mat-autocomplete>